import Vue from "vue";

export const buildingsService = {
  listBuildings,
  getBuildingById,
  getFeatures
};

function listBuildings(params) {
  return Vue.axios.get(`/v1/public/buildings`, { params });
}

function getBuildingById(id) {
  return Vue.axios.get(`/v1/public/buildings/${id}`);
}

function getFeatures(params) {
  return Vue.axios.get("/v1/public/features", { params });
}
